import { render, staticRenderFns } from "./TabellaTipiSegnalazione.vue?vue&type=template&id=4a8d3a7e&scoped=true&"
import script from "./TabellaTipiSegnalazione.vue?vue&type=script&lang=js&"
export * from "./TabellaTipiSegnalazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8d3a7e",
  null
  
)

export default component.exports